import { useMediaQuery } from "@reactuses/core";
import { useTranslation } from "react-i18next";

const AdPlanChoiceCard = ({
  label,
  value,
  description,
  childElements = null,
  isSelected,
  onChange,
  editElement = null,
  hideDivider,
  overrideStyles = {},
  hideDescriptionPrefix = true,
  disabled = false,
  isSummaryCard,
}) => {
  const mobileStyle = useMediaQuery("(max-width:600px)");
  const { t } = useTranslation(["advertising"]);

  if (isSummaryCard === "N/A") {
    return null;
  }

  const resolvedLabel = typeof label === "function" ? t(label) : label;
  const resolvedDescription = typeof description === "function" ? t(description) : description;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) {
          return;
        }
        onChange && value && onChange(value);
      }}
      translate="yes"
      style={{
        display: "grid",
        gridTemplateColumns:
          mobileStyle ? "1fr"
          : value?.icon ? "75px 1fr 20px"
          : "1fr 20px",
        maxWidth: "100%",
        boxShadow: isSelected ? "0 4px 8px 0 rgba(0,0,0,.25)" : "none",
        background:
          disabled ? "rgba(0, 0, 0, .03)"
          : isSelected ? "#F3F4F5"
          : "#FFF",
        padding: "1rem 2rem 1rem 1rem",
        margin: isSelected ? "0 2rem 1rem .5rem" : "0 2rem 0 .5rem",
        borderRadius: "10px",
        cursor: disabled ? "not-allowed" : "pointer",
        ...overrideStyles,
      }}
    >
      {value?.icon && (
        <img
          src={
            value.icon ??
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOUAAADcCAMAAAC4YpZBAAAAhFBMVEX///8AAACampqsrKw2Njb4+Pjv7+/d3d36+vqmpqb19fVERETPz88VFRXr6+vg4OBQUFBWVlbm5ubBwcG0tLQwMDDKysofHx+7u7vV1dWgoKBeXl5jY2Nubm5YWFgqKip3d3dJSUmVlZV7e3tra2uIiIg9PT2GhoYPDw8cHBwlJSULCwviK1WLAAAPpUlEQVR4nO1d6YKyvA52BUQEBUTEZdyd0fu/v+PeFNI2RUB8z/f8m2GxoWmavY3GZ+F0xuNJW3KD4QRB4FY2nlLQbl5xXhnCGzrXG8ZJlYMqGkHzgVOMXvfmzxtaFY+sQLyIvGDuZy5bCbgefmB8hSA6AyqapzQd0yW8/K1k+s0Ulh68vElfjj410Hcw/UuT0Wwm1vNqdMhedT453Hwwf7JkNJuj+3R2MxN5xeDryDTGGB0XbC7TGaBf4IKshKo1/LWAjmazH22F137MTw9cCyMhIXKMv2g2rbxEXmbT/vTgqbB33MDn5lBK1+YE/1x+i0674qiYWQ2rJyZy5TYi7h9LS/0LNcCCJ/L2P4+f3hc6t83DTH+W+uPIDbn/WGdW+xchcv+wVSJOg9h/bvBU8OzXZyYXsz9eE8l0Ooe7ILNH6wGOX/sc88WcmAHqXoM3X5p/tedZOGPrlPHsA7m0nvLXQvDcoPa75gzOVuZq8JzOXubS8ZuohJvGb1Zhs5OrgrvKkgG1+4HQgVIXGNCkGiI3+E40Rf4N1aV52YN8H1MoR7KMKQB0jnRqP5UN3glwxqYNAacXBOWOryB0FDybhQVdQIuSh1cQPOjV2lCegNM//gZ+vaIF+c9T38/x6/c4uaCcXapvX4Pbt+WPrihwk6N0m0P9/lTF8IoC3BhUPMtp6t8hXx/gfCKjtgwh9PYdPz1wPbjNPOh/jdfngZaapiyIOkSNsFQTlcaX8esV3kCXyOG38esVbV0qvy5McoMmz5J0wfrBO6lJY+h/erh5ocWz38mvVwh8zRjI9nb94AMbrJ8FUOrXtXdOSgAMauSqzRYuninzJZBT6U5eV780Q+SO/6j8j8rvwn9U/kfld+H/jkpzmkHw9w9QabnQKhkgYFfrH2THMU3mGt6C/j7sfnrEurCdPZ3AFw7JN3m33FY/B41XDGbhl/h+puKUSQome0L46NOYSnPuaFjUnHH9hZoGAs5IdkVtYKN52vmwr6vEjUVJ3LkgqLP5MOz3hA6CXf3EbYTUVdzQWbXagSlYZ5bvxMl+ecYf/a3bdOIRrv4idgkTYtlea4Z6qI+18uxhovW8d3RYzouxPWhWn4QRv5Md3iJHqoeRZF/0W5e9c5opZvpbSfUX2xYxoh2uM2TWIzPGy3x/OY3m9tCZiw2tdmaB1kEGTdODmsn10EeEaCZes720uP68hT1NffpzKBeLr48iia6b6SDSp9NjjNR4kIpZHq9U6F/ZnemQ4Gdn000JHrVfg2mB0uXmpWqoPippedY6ETiLUSmfH5svMPr5YF1UqkCGYi5RqUxXFK8/ZqPEPJEkbYxOJVd78bncYJcTryOaLqZBZUoGfWjb5AQENWLe0Rk1VzDU/EidLfellcvGcnuL2Ww2ZzVt/dk2VK1kjmlHHzBQuJ1SKQKjTCnbY7UpJohz637A/85tIoo5cQU0XrGVm2ccmZWbYdySUQgSE+nAwNCRkmnD1V95TvuB/uMgfoeiL13TXJ+OilUgKHrWcp7rKv3Q8rIuuCtXm6tnwalUJNARkp7lmuGCfGfBgBJekaBsi5x7AGPpG6A0XxdIhAoWYMKxwoVFyquUTxEs6aww8xJWgKg2MckmwqDgB+C0r1CdBdJdIXoaFqDlkCStF5IN8DWP5G+B21ZlcT+4UFTaaJfdmt5wfBbLHct1py7IDa+smQFcJ6p7AZWZWWBL9qRQnsBu8pN/3FqwQBm70nySUTklU9kApeEVbSaguEnBaQ05leyaspIESOqKWBYw7Ep5s4xKpvErWxv6TEucVGOAAVGgNmylVBoP+TNT/yjYkCpRZn22exFK7KRUNtzV5Nz82RBmB2wmlVTXRFq/J6fy2nI0InnngGFDmPn3AbRvQjhKRSUZzD9bSQcysCwJdxdGJZB5Veiy7NcOhLsBle+5GsH+VUHUBCimlNa24PZBbNgc9LYE9qJdvpHrAAgfSpTYgs0aD8sRxHyvw3vMcO/kHTsdTAuhhfzlKaQ/dDYGUi/34MlgQZoOKQ4VIbRBzKgSE2js5QfA2NwQWmdcgSSQcFBq6g+Az1W+9sN8TUQhkEk8yEnmlOWHl26WWEyhXBEfUWZa0pQZl2mWpYcSbKYUkE0gpeuHtAEajPVLr7sFv0VvkX7ESIOgvMRiDpR6UtmIFU5Z0kJj7tGaUtkwelJRS2qtwags/TyBnFReYAc9Dq01o5LUW6P+c4m+ig2bZEx9J5VAm5n8w1SCQAQlM+I/KgtGDir93nHbw1jyX6KyfdsrfxD95h+i8kVK1pD4d6hksflsg/F/h0rm3cqm/WpSyWy+0i2v/FRmPZWMyjPFi/kyVMsP7r1BZYbPWGUYzZH8cDlNyncVaK9LRmUz6ULYwO91oOWexYfB4E9R41AItKlUuX1uIOdEuF4lhXzaOwmp2L1uR7NpU6nyVN5Qn5q1O/R1n7WayFWZI84DfSqVnkqyR/YKq4paBNNh/kKqtq5MN6THsKb7+WxbWsjLi+LNMn0I15HqyF+htL1A19ce2Raq1D99WIbXmq/Rct7zeJTQeE02mwP61LwCtQX3mXVaO0Vfl52iRu8O7My9O4b0+glw3FtxMtkPSOmQFwlJiWNGW6SbweGoo6yBaHQxQS/LaM81eiwMY8JKcT3TNH22uBPP05uSgqmc9tZ0Cu+YJMQfJlYmYiiQY91ojx1JRcCWtMJ06rzSeAmx3XtJauFKWvqhAKWTyztUPjX/vzem0m9r9LQVYKuUJu9Q+ehVkvskPsPcHLQbh6PYKay/t6i8LKggyJu55RzXJApOo90miaKLHrRZjYQFP3K+ZVRWWRrixwr964b+sRenB29FLYGFvJXM5+uwiwqSdh7j9NriKWETeHQMwXZoOyv0+cFRSKfxjNhX1DjD3MywEfJYxIr9wevh63klkkOPeF4VRLoRgU/7G9rSCXDZ3BG1tvN7rdxr0o6S23b+swgd6aZpGfFO6XKarFsafqTpDtUkDptik6yMgNvO++LXez2CDj4Ldb2BU0GLOK18QimM3irzKc8tZD5tZ6M+maC/zcdOhsBZ97dxgHTumtd9KIymWoZwd4r0N7ohfVx4N9oqu0eeD3szv/aUaeXyRGe+aIWXfTbcrIZPQ7OvVpOeA3e2sjpVqPR7hIZ88/a7rnkhnSiWBKZxw5WgwdoL7C2J4s5mZ0sxEdWYEi3vO+TBAMvskXqXPrjPUjTkOx2d4tL6Y1LI4IGJ2Mg099RDXFb3B6Tfd1R4a1qqJ+UGtCTFiLc6tsNNcREvyc6up5kiT4N/pLtTVqlnLS9cap1Rc39FtsfZA9ugvMxov00o+r6Di3d5BLVzsI0Cbq4PtuC8l2GrdEUyoPaSfebZGgEhPjZvPRTrALCL03Az0uA06/mVdD4ytzRJFF9bxsQ7JZf/zNoGW2CgKUWUOjv8YswHFfZNNmLKhI6dhCCwtmkvAds52lx9+LA4tZIOs7ef9x/L6NyZH3vudfmRl+0N6w0ycBYZ3YAqsIme8lggLMP3vQt8/8VxHllNmqwT3DxiVO5AxLsyHwQNtCbQO7F5xKicQY6tWePrHkIUh7XcPGLptQsY16/bwWBSMjubqcI8YoJt0/CY/+lNx3vxELplZhTziN0egv6XVVSB6SHI0neZxAXNPAItDCIuEFyHfrMQZkYnP62mxKmwmcbxZ3JhvwqKULXAt4Bsjlp088hYs+euZ8WDvle0isnKABOefuZQe1MihFxwy/wCG1NZKroVt/SPioFdnPSOd0ipFLdnwXHjJTWUuztcRrEOq/ANYnV0ayOlTzwyRoAfU2fsZLzk23hBViKjNRxoX8NzmHG5PNgAFAaWkUDLHU3fIUkQP7VT0luD+Bn99/msk+d1dKRzlk49OaFW5jwacjM/5ASUl6sB9JhWtPHKBcS6WLZdYXv89ih99w91VcZZzyXoowT4owSNHfdjzBMkJuj1EKs6HQUQIcusF7MMCDygSb1dnJWFMM93vHfYIGwzOqK+uV9ajpqNJfMtoNSy2f9HBZN4fbskjHHYbWLHidqbxVDgHRjTZjJYZx8dpGrdGZ+QKh01Yeq5NzjQ0lrQs6X26e0HqBll5NC6q3TuLBF/pLT8boJ42kdZQQ68euU0evTbOuGRJ5akJemskUfRhFUQqS6Yvhe8jSahQ1I42MWY9YhviMD5UF42kT1d0AkdBRQTxMIiEX2RwAJaWKm9AY2AkF5zwZwmWU1MfLeF1o/FgoGHso3McKWIWR0SmnLuYn6hlUx7AwpK+SVvbjAXCt3TLCJqmSHysQ7ywQOWraQ3oBugLVJWmXQ+EaYY6yeqtcw+TGU+di9h0uh8mB/RQnccLvaNFmp3BGPZc4WHQ9xS8q/whEYKhhCR1QeKOwdo7NqtjiwzCtphEFUUgkATTWhmRpfJAx2N3Zi256engnUerFvTsgO8aBLYiroxgA9EZp5glbVbR+1SAxEhUh/QoWsy2izriBpJDdqlbblo9pdOpa3PpCxBY++iBzU+MVmYZUyovUEyUDVP4mWfSe1jl9J4w6x4Ey5AEtIoZ4Rx4INEElixMpv9hk2hW5KHqgHarwF+kZXkNgv7pDj+5k5RErfbQr7sLs9nZFvtSXyT6BwjAYa9QhZohH3ZfDYigWWjHHVex7fTa3yMWfN6G52z4hVOxiFMwyx4h3GtBDE+yA1Xs2BsgZ1IJDaAx4swviAUl2d0ktxOewdh1r93HBpAd8rsJY6Axh+ucl6SpKM6gAwHpgb8vufOAA0SUiLaFMicfvqQOC8R7zJz7RkwMDVg+GaioMFkC9ez1RGki81RIRWIGXfc0ylhsBIk8x5rQ6YJxrInxl+CjPrzXOh9cFtCUfx7pDKu0UO8Jr9FtCIAGvszK8bd4nXQwnK0+xADoTg+Lyg7i9XGPtSyGJ8Ue+HdyPQF5QmyEsoHTHH25yFWqArdNlYlMi5KNQYL8PKXv0dT/Qc72maFBFxfdMoK2dw9mta8KSyCDPKIwkaC8+pCg21QT9sNk71ggfp7lAfWBSYoe8rg1FZT6bBFdcOXCQ0zE2oFeC1MYcx6h8LBrypRx2AHQmN0vHDA1mKbR4G5kwlFvglpS6FRXq6JxDVWp+0tZaTrB5u14JYimfWO9MHrADrrMQO7RbZKU9BwXdEh+uqzdz+oEYvmSoYTMTKkCR/9MZLjWglKTTmPVlllEWH2t4aF5Voae40MgzFW1lwU0gJorJ/0KYHfprnGmr+tcgOpXIrxX/EHRISE+tBhuR76K/ztk6/6vVIWhrmQMu6JpNC/Dz9Krv3znNJqonzMrnrQSOwv9x2Y7hHj6rytqE1KdbBNviNiZxbXrbtoQfCdKNlcEQZOaST+D3nb4ZuNzjLRAAAAAElFTkSuQmCC"
          }
          alt="Placeholder logo"
          style={{
            width: "75px",
            height: "70px",
            background:
              disabled ? "rgba(0, 0, 0, .03)"
              : isSelected ? "#F3F4F5"
              : "#FFF",
          }}
        />
      )}
      <div
        style={{
          padding: "0 1rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h4
            style={{
              fontSize: "16px",
              fontWeight: 500,
              margin: "0",
            }}
          >
            {resolvedLabel}
          </h4>
          {editElement}
        </div>
        <p
          style={{
            fontSize: "16px",
            color: "#73706E",
            paddingBottom: resolvedDescription ? "1rem" : "0",
            borderBottom: resolvedDescription && !isSelected && !hideDivider ? "1px solid rgba(98, 64, 127, .5)" : "0",
          }}
        >
          {resolvedDescription ?
            hideDescriptionPrefix ?
              resolvedDescription
            : t(($) => $.advertising["Description: {description}"], { description: resolvedDescription })
          : null}
        </p>
        {childElements}
      </div>
    </div>
  );
};

export default AdPlanChoiceCard;
